import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const getToken = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

export const getProfessionals = () =>
  axios.get(`${API}/api/professionals`, getToken());

export const createProfessional = (data) =>
  axios.post(`${API}/api/professionals`, data, getToken());

export const updateProfessional = (id, data) =>
  axios.put(`${API}/api/professionals/${id}`, data, getToken());

export const deleteProfessional = (id) =>
  axios.delete(`${API}/api/professionals/${id}`, getToken());